import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';
import { realestatedata } from "variables/lists/charts";
import UserService from "services/UserService";
import axios from "axios";
import { getIndicators, getChartpoints, getChartsV2 } from "services/ConfigServices";
import { charttext } from "variables/chart";
import { definitionData, eosprotocoleData } from "variables/MBM/lists/iotdevices";
import moment from "moment";
import { dico } from "variables/lists/dico";
import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddChart from "./AddChart";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useChartsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const charts_admin = permis.includes("charts_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [results, setResults] = useState({ charts: [] });
  const [loading, setLoading] = useState(false);
  const [charts, setCharts] = useState([]);
  const [indicatordata, setIndicatordata] = useState([]);
  const [pointdata, setPointdata] = useState([]);
  const [avalaibleDico, setAvailableDico] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      axios
        .get(
          getChartsV2(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setResults(res.data);
          // setCharts(res.data.charts);
          setLoading(false);
        });
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
    }
  }, [chartIdGroup, refresh]);

  useEffect(() => {
    axios
      .get(
        getIndicators(chartIdGroup, "charts", ""),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setIndicatordata(res.data.indicators || []);
      })
      .catch(() => { });
  }, [chartIdGroup]);

  useEffect(() => {
    axios
      .get(
        getChartpoints(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPointdata(res.data.points || []);
        let tmpdefinitiondata = dico.filter((item) =>
          res.data.points.find((x) => x.definition == item.id)
        );
        setAvailableDico(tmpdefinitiondata);

      })
      .catch(() => { });
  }, [chartIdGroup]);

  console.log(results);
  console.log(charts);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `charts`, []).filter(
    (item) =>
      (item.parameters.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = charts.map((item) => {
      let charttoexport = {};
      charttoexport[charttext.id] = item.id;
      charttoexport[charttext.name] = item.parameters.name;
      charttoexport[charttext.visibility] = item.accountid ? groupInfoListById["" + item.accountid] : "";
      charttoexport[charttext.group] = item.accountid || "";
      charttoexport[charttext.parameters] = JSON.stringify(item.parameters);
      return charttoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {charts_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddChart
                refetch={refreshTable}
                onClick={handleClear}
                indicatordata={indicatordata}
                pointdata={pointdata}
                realestatedata={realestatedata}
                avalaibleDico={avalaibleDico}
              />
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        {/* <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!charts || charts.length < 1} />
        </UploadButton> */}
      </>
    );
  }, [filterText, resetPaginationToggle, charts, indicatordata, pointdata, avalaibleDico]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setCharts,
    setLoading,
    indicatordata,
    pointdata,
    avalaibleDico
  };
}
